import React, { useMemo } from 'react';
import { capitalize, cn } from '@express-labs/raven-tools';
import s from './ColorSwatch.scss';

export type ColorSwatchProps = {
  id?: string;
  className?: string;
  colorCode?: string;
  colorName?: string;
  backgroundImage?: string;
  backgroundColor?: string;
  tabIndex?: number;
  isRadio?: boolean;
  checked?: boolean;
  value?: string;
  onChange?: (
    ev: React.ChangeEvent<HTMLInputElement>,
    productId?: string
  ) => void;
  onFocus?: (ev: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (ev: React.FocusEvent<HTMLInputElement>) => void;
  onMouseEnter?: (ev: React.MouseEvent<HTMLInputElement>) => void;
  onMouseLeave?: (ev: React.MouseEvent<HTMLInputElement>) => void;
  productId?: string;
  size?: 'small' | 'large';
};

const ColorSwatch = ({
  id,
  isRadio = true,
  className,
  colorCode,
  colorName,
  backgroundColor,
  backgroundImage,
  tabIndex = 0,
  checked,
  value,
  onChange,
  onBlur,
  onMouseEnter,
  onMouseLeave,
  productId,
  size = 'small',
}: ColorSwatchProps) => {
  const style = useMemo<React.CSSProperties>(
    () => ({
      backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
      backgroundColor: backgroundColor ? backgroundColor : undefined,
    }),
    [backgroundImage, backgroundColor]
  );

  return (
    <div className={cn(s.colorSwatchWrapper, className)}>
      <label htmlFor={id} className="srOnly">
        {colorName}
      </label>
      <input
        aria-label={colorName}
        checked={checked}
        className={
          isRadio
            ? s[`colorSwatchCircular${capitalize(size)}`]
            : s[`colorSwatchSquare${capitalize(size)}`]
        }
        data-testid={`colorSwatch-${id}`}
        data-productid={productId}
        data-colorcode={colorCode}
        data-colorname={colorName}
        id={id}
        onBlur={onBlur}
        onChange={onChange}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        tabIndex={tabIndex}
        type={isRadio ? 'radio' : 'checkbox'}
        value={value}
      />
      <div
        className={cn(
          s[`outline${capitalize(size)}`],
          isRadio ? s[`outline${capitalize(size)}Circular`] : ''
        )}
      >
        <div
          className={cn(
            s[`image${capitalize(size)}`],
            isRadio ? s[`image${capitalize(size)}Circular`] : ''
          )}
          style={style}
        />
      </div>
    </div>
  );
};

ColorSwatch.displayName = 'ColorSwatch';
export default ColorSwatch;
